module.exports = __webpack_public_path__ + "img/90.36e234d3.png";